import { NoteTextOutlineIcon } from './NoteTextOutlineIcon';

/**
 * author: Michael Richins
 * id E39F6865-3E35-4BE8-8440-643FC83351F7
 * name note-text-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-text-outline.svg
 * tags
 */
export const PaperTextOutlineIcon = NoteTextOutlineIcon;
export default PaperTextOutlineIcon